module.exports = __webpack_public_path__ + "fo.svg?c2f634751d1be4f5bb02637a2648823f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/fo.svg
// module id = 1356
// module chunks = 0